export default {
  bind (el, binding) {
    el._tooltipText = binding.value || el.getAttribute('data-tip')

    el._showTooltip = () => {
      const text = el._tooltipText
      if (!text) return

      const tip = document.createElement('div')
      tip.className = 'custom-red-tooltip'
      tip.innerText = text
      document.body.appendChild(tip)

      const rect = el.getBoundingClientRect()
      const top = rect.top - tip.offsetHeight - 10
      const left = rect.left + rect.width / 2 - tip.offsetWidth / 2

      tip.style.top = `${top}px`
      tip.style.left = `${left}px`

      el._tooltip = tip

      // 🔥 abilita la transizione al frame successivo
      requestAnimationFrame(() => {
        tip.classList.add('show')
      })
    }

    el._hideTooltip = () => {
      if (el._tooltip) {
        el._tooltip.classList.add('fade-out')
        setTimeout(() => el._tooltip && el._tooltip.remove(), 200)
      }
    }

    el.addEventListener('mouseenter', el._showTooltip)
    el.addEventListener('mouseleave', el._hideTooltip)
  },

  update (el, binding) {
    // 🔥 qui aggiorni il testo quando cambia la lingua
    if (binding.value !== binding.oldValue) {
      el._tooltipText = binding.value
    }
  },

  unbind (el) {
    el.removeEventListener('mouseenter', el._showTooltip)
    el.removeEventListener('mouseleave', el._hideTooltip)
    if (el._tooltip) el._tooltip.remove()
  }
}
